import {
  ApiCartChangeCartBirthDateRequestedAction,
  apiCartChangeCartBirthDateFailed,
  apiCartChangeCartBirthDateSucceeded
} from '../../../api/cart/changeCartBirthDateApi';
import { call, put } from 'typed-redux-saga';
import changeCartBirthDateAction, {
  ChangeCartBirthDateActionInput,
  ChangeCartBirthDateActionResult
} from '@spa/lib/actions/cart/changeCartBirthDateAction';

function* changeCartBirthDateSaga({
  payload: { actionId: requestedActionId, birthDate, customOrderType, parentActionId }
}: ApiCartChangeCartBirthDateRequestedAction): Generator {
  try {
    const input: ChangeCartBirthDateActionInput = { customOrderType, birthDate };
    const { cartId, result }: ChangeCartBirthDateActionResult = yield* call(
      changeCartBirthDateAction,
      'changeCartBirthDateAction',
      input
    );
    yield* put(
      apiCartChangeCartBirthDateSucceeded({
        cartId,
        parentActionId,
        requestedActionId,
        result
      })
    );
  } catch {
    yield* put(
      apiCartChangeCartBirthDateFailed({
        parentActionId,
        requestedActionId
      })
    );
  }
}

export default changeCartBirthDateSaga;
